import GeneratedSchedulingObjectStore from "./generated/GeneratedSchedulingObjectStore"

class SchedulingObjectStore extends GeneratedSchedulingObjectStore {

}

export const schedulingObjectStore = new SchedulingObjectStore()
